import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { SharedService } from 'src/app/core/services/shared.service';

@Component({
  selector: 'app-cambiar-contrasena',
  templateUrl: './cambiar-contrasena.component.html',
  styleUrls: ['./cambiar-contrasena.component.scss']
})
export class CambiarContrasenaComponent implements OnInit {

  usuario = '';
  nombre = '';
  superUsuario = false;     

  actual = '';
  nueva = '';
  confirmacion = '';

  verActual = false;
  verNueva = false;
  verConfirmacion = false;

  cargando = true;
  guardando = false;
  intento = false;          
  error = '';

  constructor(public activeModal: NgbActiveModal, private dataService: SharedService) { }

  ngOnInit(): void {
    this.dataService.Ejecutar('api/servicios/DatosCambioContrasena', JSON.stringify({ LLAVES: [{}] })).subscribe({
      next: (datos: any) => {
        const d = (datos && datos[0]) ? datos[0] : {};
        this.usuario = d.S00USR || '';
        this.nombre = d.S00NOM || '';
        this.superUsuario = d.SUPER_USUARIO === true;
        this.cargando = false;
      },
      error: (err: any) => {
        this.cargando = false;
        this.error = this.textoError(err);
      }
    });
  }

  get faltaActual(): boolean { return !this.superUsuario && !this.actual; }
  get faltaNueva(): boolean { return !this.nueva; }
  get noCoinciden(): boolean { return !!this.nueva && this.nueva !== this.confirmacion; }
  get valido(): boolean { return !this.faltaActual && !this.faltaNueva && !this.noCoinciden; }

  cambiar(): void {
    this.intento = true;
    this.error = '';
    if (!this.valido || this.guardando) return;

    this.guardando = true;
    const llaves = { LLAVES: [{ ACTUAL: this.actual, NUEVA: this.nueva, CONFIRMACION: this.confirmacion }] };

    this.dataService.Ejecutar('api/servicios/CambiarContrasena', JSON.stringify(llaves)).subscribe({
      next: (datos: any) => {
        this.guardando = false;
        const d = (datos && datos[0]) ? datos[0] : {};
        this.actual = '';
        this.nueva = '';
        this.confirmacion = '';
        setTimeout(() => this.activeModal.close(true), 0);
        Swal.fire({
          icon: 'success',
          title: 'Contraseña actualizada',
          text: d.MENSAJE || 'El cambio de contraseña se realizó exitosamente.',
          confirmButtonText: 'Aceptar'
        });
      },
      error: (err: any) => {
        this.guardando = false;
        this.error = this.textoError(err);
      }
    });
  }

  private textoError(err: any): string {
    if (!err) return 'No fue posible cambiar la contraseña. Intente nuevamente.';
    if (typeof err === 'string') return err;
    return err.error?.message || err.message || 'No fue posible cambiar la contraseña. Intente nuevamente.';
  }
}
